module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/arrow02-898d778175929021df1ff82647d174eb.svg";